import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { AuthStateType } from "types/auth";

import { extraReducers } from "./auth.extraReducers";

export const initialState: AuthStateType = {
  username: "",
  token: "",
  isLoading: false,
  isAuthenticated: false,
  messageRes: "",
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth: () => initialState,
    updateAuthInformation(state: AuthStateType) {
      state.isAuthenticated = true;
      state.username = localStorage.getItem("username") || "";
      state.token = localStorage.getItem("token") || "";
    },
  },
  extraReducers,
});

export const selectIsAuthenticated = (state: ApplicationRootState) =>
  state.auth.isAuthenticated;
export const selectUsername = (state: ApplicationRootState) =>
  state.auth.username;
export const selectMessageRes = (state: ApplicationRootState) =>
  state.auth.messageRes;
export const selectIsLoadingAuth = (state: ApplicationRootState) =>
  state.auth.isLoading;
export const selectToken = (state: ApplicationRootState) => state.auth.token;

export const { resetAuth, updateAuthInformation } = authSlice.actions;

export default authSlice.reducer;
